module.exports = __webpack_public_path__ + "img/expectMore.46c5dbc8.png";